<template>
  <div>
    <div ref="messageDisplay" style="max-height: 459px; overflow-x: auto">
      <i v-if="loading" class="fas fa-spinner fa-spin"></i>
      <div v-if="!loading && messages.length < 1" class="d-flex text-center">
        <small>{{ $t("noMessagesFound") }}</small>
        {{ orderItemid }}
        <small v-if="!orderItemid">{{
          $t("You are unable to reply on this product right now.")
        }}</small>
      </div>
      <b-alert
        v-for="conversationMessage in messages"
        :key="conversationMessage.created"
        :variant="conversationMessage.variphoneMessage ? 'primary' : 'success'"
        class="my-4"
        show
      >
        <div
          :class="`d-flex message-header ${
            conversationMessage.variphoneMessage ? 'mr-2' : 'ml-2'
          }`"
        >
          <strong>@{{ conversationMessage.sender }}:</strong>
          <small>{{ formatDateTime(conversationMessage.created) }}</small>
        </div>
        <p>{{ conversationMessage.message }}</p>
      </b-alert>
    </div>
    <div>
      <form v-if="orderItemid" class="mt-3" @submit.prevent="postMessage">
        <b-form-textarea
          v-model="message"
          :placeholder="$t('enterYourMessageHere')"
        ></b-form-textarea>
        <div class="d-flex actions">
          <b-button variant="primary" type="submit" class="mr-2 mt-2"
            ><i v-if="loading" class="fas fa-spinner fa-spin"></i
            ><span v-else>{{ $t("send") }}</span></b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {
  getOrderItemMessages,
  createNewOrderItemMessage,
} from "@/services/cartItem"

import dayjs from "dayjs"

export default {
  name: "OrderMessagesBody",
  props: {
    orderid: {
      type: String,
      required: true,
    },
    orderItemid: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      message: "",
      loading: false,
      posting: false,
    }
  },
  watch: {
    orderItemid(orderItemID) {
      if (orderItemID) {
        this.getMessages()
      }
    },
  },
  created() {
    this.getMessages()
  },
  methods: {
    async getMessages() {
      if (!this.orderid || !this.orderItemid) return
      this.loading = true
      const messages = await getOrderItemMessages({
        orderID: this.orderid,
        orderItemID: this.orderItemid,
      })

      this.messages = messages
      this.loading = false
    },
    async postMessage() {
      this.posting = true
      const result = await createNewOrderItemMessage({
        orderID: this.orderid,
        orderItemID: this.orderItemid,
        message: this.message,
      })

      this.message = ""

      this.$toasted.success(result.message)
      await this.getMessages()
      this.posting = false
    },
    formatDateTime(dateTime) {
      return dayjs(dateTime).format("DD-MM-YYYY HH:mm")
    },
  },
}
</script>

<style></style>
